import React, { useContext, useEffect, useState } from 'react';
import './customCursor.css';
import { MouseHoverContext } from './mousHoverContext';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [clickEffect, setClickEffect] = useState(false);
  const [moveDirection, setMoveDirection] = useState(''); // Track movement direction
  const [isMoving, setIsMoving] = useState(false); // Check if the mouse is moving
  const {mousehover, setMouseHover}= useContext(MouseHoverContext);
  const [mouseClass, setMouseClass] = useState('custom-cursor'); // Track movement direction


  useEffect(() => {
if(mousehover) setMouseClass("custom-cursor2 hover")
  else setMouseClass("custom-cursor")
  }, [mousehover]);

  useEffect(() => {
    let lastX = 0;
    let lastY = 0;
    let moveTimeout;

    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsMoving(true);

      clearTimeout(moveTimeout);
      moveTimeout = setTimeout(() => {
        setIsMoving(false); // Reset the dot when movement stops
        setMoveDirection('reset-dot');
      }, 100); // Reduce the delay to make re-centering faster

      // Determine direction of mouse movement
      if (e.clientX < lastX) {
        setMoveDirection('move-left');
      } else if (e.clientX > lastX) {
        setMoveDirection('move-right');
      } else if (e.clientY < lastY) {
        setMoveDirection('move-up');
      } else if (e.clientY > lastY) {
        setMoveDirection('move-down');
      }
      lastX = e.clientX;
      lastY = e.clientY;
    };

    const handleMouseDown = () => {
      setClickEffect(true);
    };

    const handleMouseUp = () => {
      setClickEffect(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <div
      className={`${mouseClass} ${clickEffect ? 'click' : ''} ${isMoving ? moveDirection : 'reset-dot'}`}
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
    />
  );
};

export default CustomCursor;
